import { settingsPage as EnUsSettingsPage } from '../en-us/settingsPage';
import { AgResourceLanguage } from '../types';

export const settingsPage: AgResourceLanguage['settingsPage'] = {
  ...EnUsSettingsPage,
  title: 'Cuenta',
  emailAndPassword: {
    title: 'Correo Electrónico y Contraseña',
    changePasswordButton: 'Cambiar Contraseña',
    emailChangeInfo: {
      informationText: 'El correo electrónico solo puede ser cambiado a través de',
      linkText: 'Atención al Cliente'
    }
  },
  userInfo: {
    editButton: 'Editar',
    title: 'Nombre Completo'
  },
  modal: {
    changePassword: {
      cancelButton: 'Cancelar',
      confirmPasswordLabel: 'Confirmar Contraseña',
      header: 'Cambiar Contraseña',
      infoBanner: 'Si cambias tu contraseña, se cerrará tu sesión automáticamente',
      newPasswordLabel: 'Nueva Contraseña',
      saveButton: 'Guardar',
      title: 'Cambiar Contraseña',
      success: 'La contraseña ha sido cambiada',
      reloginError: 'Algo salió mal, se cerrará tu sesión automáticamente'
    },
    editFullName: {
      cancelButton: 'Cancelar',
      firstName: 'Nombre',
      header: 'Editar Nombre Completo',
      lastName: 'Apellido',
      saveButton: 'Guardar',
      title: 'Nombre Completo'
    }
  },
  constants: {
    FULL_NAME_SUCCESS: 'Nombre completo cambiado con éxito',
    PASSWORD_MATCH_MESSAGE: 'Las contraseñas no coinciden',
    SETTINGS_ERROR: 'Algo salió mal. Por favor, inténtalo de nuevo',
    nameError: 'Debe contener al menos 1 carácter',
    latinNameError: 'Debe contener solo caracteres latinos',
    spacesNameError: 'No se permiten solo espacios',
    minLength: 'Debe contener al menos 8 caracteres',
    uppercase: '1 letra mayúscula',
    lowercase: '1 letra minúscula',
    number: '1 número',
    spacesPasswordError: 'No se permiten espacios',
    passwordCaption: 'Debe contener al menos 8 caracteres'
  }
};
